import { render, staticRenderFns } from "./HomeNavigation.vue?vue&type=template&id=1152130e&"
import script from "./HomeNavigation.vue?vue&type=script&lang=js&"
export * from "./HomeNavigation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports